import React from 'react';
import moment from 'moment';

export const statusValues = {
  "0":
  {
    "text":"Inactive",
    "cssClass":"bg-label-danger"
  },
  "1":{
    "text":"Active",
    "cssClass":"bg-label-success"
  },
  "2":{
    "text":"Draft",
    "cssClass":"bg-label-warning"
  },
  "3":{
    "text":"Draft",
    "cssClass":"bg-label-warning"
  },
  "4":{
    "text":"Budget Exceeded",
    "cssClass":"bg-label-danger"
  },
  "5":{
    "text":"Yet to be live",
    "cssClass":"bg-label-info"
  },
  "6":{
    "text":"Expired",
    "cssClass":"bg-label-danger"
  }
}

export const campaignListMessages = {
  noValidCampaigns:"The campaign remains incomplete. Please provide all necessary details."
}


export const options = {
  columns: [
    // { id: 1, name: 'campaignId', label: 'Date', sortable: true, type: 'date', component: row => moment(row.Date).format('D-MMM-YY'), },

    { id: 1, name: 'campaignId', label: '', sortable: true, type: 'string', expand: true, component: row => "" },
    // { id: 2, name: 'campaignName', label: 'BEKI CAMPAIGN NAME', sortable: true, type: 'string',component: (row) => <div title={row.name}>{}</div> },
    { id: 2, name: 'campaignName', label: 'BEKI CAMP. NAME', sortable: true, type: 'string', containsPlatformName: true, component: (row) => <div style={{ color: "#303890" }} title={row.campaignName}>{row.campaignName.length > 98 ? `${row.campaignName.slice(0, 98)} ...` : row.campaignName}</div> },

    { id: 3, name: 'platforms', label: 'PLATFORM', sortable: true, type: 'number' },
    { id: 4, name: 'campaignId', label: 'BEKI CAMP. ID', sortable: false, containsPlatformName: true, type: 'number' },
    { id: 5, name: 'advertiser', label: 'ADVERTISER', sortable: true, type: 'string', },
    { id: 6, name: 'budget', label: 'BUDGET', sortable: true, type: 'number' },
    { id: 7, name: 'startDate', label: 'START DATE', sortable: true, type: 'date', component: row => moment(row.startDate).format('D-MMM-YY') },
    { id: 8, name: 'endDate', label: 'END DATE', sortable: true, type: 'date', component: row => row.endDate ? moment(row.endDate).format('D-MMM-YY') : '-' },
    {
      id: 9, name: 'status', label: 'STATUS', sortable: false, type: 'string', component: (row) => {
        const badgeData = statusValues[row.status];

        return <p className={`badge ${badgeData.cssClass}`}>{badgeData.text}</p>;
      }
    },
    { id: 10, name: 'recos', label: 'RECOM...', sortable: true, type: 'number', component: (row) => <div class="d-flex align-items-center">{row.recos} <a><i class="ti ti-external-link ti-xs pl-1 text-primary"></i></a> </div> }

  ],
  keyCol: 'campaignId',
  actions: [
    {
    type: 'edit',
    text: '',
    icon: 'ti ti-pencil color-beki',
    tooltip: 'Edit',
    iconType:'new'
  },
  {
    type: 'view',
    text: '',
    icon: 'ti ti-eye color-beki',
    tooltip: 'View',
    iconType:'new'
  },
  {
    type: 'chart',
    text: '',
    icon: 'ti ti-chart-bar color-beki',
    tooltip: 'View Campign',
    iconType:'new'
  },],
  recActive: true,
  showSwitch:true,
  status: {
    key: 'status',
    active: '1',
    activeIcon: 'ti ti-toggle-left color-beki ti-lg',
    inActiveIcon: 'ti ti-toggle-right color-beki ti-lg',
    confirmation: true,
    activeConfirmationMessage: 'Kindly confirm the deactivation of this record.',
    inActiveConfirmationMessage: 'Please confirm if you wish to activate this record.',
  },
  actionsThead: true,
  sortable: true,
  dateType: true,
  searchable: true,
  searchColumns: [
    { key: 'Date', func: (row) => moment(row.Date, 'YYYY-MM-DD').format('D-MMM-YY') },
    { key: 'domain' },
    { key: 'partner' },
    { key: 'adUnitId' },
    { key: 'totalAdReq' },
    { key: 'property' },
    { key: 'totalAdRes' },
    { key: 'resRate' },
    { key: 'totalAdServed' },
    { key: 'fillRate' },
    { key: 'totalRevenue' },
    { key: 'eCPM' }
  ],
  defaultSortParams: {
    sortBy: 'Date',
    sortOrder: 'desc'
  },
  paging: true,
  showSearch: false,
  defaultPagingParams: {
    pageSize: 25
  },
  // CSVDownload: {
  //   type: 'mediaReport',
  //   showCSVButton: true,
  //   buttonName: 'Download',
  //   saveFileName: 'MediaReport'
  // }
}

// export const options = {
//   columns: [
//     { id: 1, name: 'id', label: 'Campaign ID', sortable: true, type: 'number', expand: false },
//     { id: 2, name: 'name', label: 'Campaign Name', sortable: true, type: 'string', expand: true,component: (row) => <div title={row.name}>{row.name.length > 98 ? `${row.name.slice(0,98)} ...`: row.name }</div> },
//     { id: 3, name: 'platforms', label: 'Platform Name', sortable: false, type: 'string' , component: (row) => row.platforms ? row.platforms.map((ro, i) => <span>{`${ro}`} {row.platforms.length - 1 === i ? '' : <>, &nbsp;&nbsp;</>}</span>) : "-" },
//     { id: 4, name: 'advertiser', label: 'Advertiser', sortable: false, type: 'string' , component: (row) => (row.advertiser && row.advertiser.value) ? row.advertiser.value : "-" },
//     { id: 5, name: 'sDate', label: 'Start Date', sortable: true, type: 'date', component: (row) => row.sDate ? moment(row.sDate).format("YYYY-MM-DD") : "-" },
//     { id: 6, name: 'eDate', label: 'End Date', sortable: true, type: 'date', component: (row) => row.eDate ? moment(row.eDate).format("YYYY-MM-DD") : "-" },
//     { id: 7, name: 'status', label: 'Status', sortable: false, type: 'string',component: (row) => (row.Cmpstatus && row.Cmpstatus.value) ? row.Cmpstatus.value : "-" },
//     // { id: 3, name: 'dsp platform', label: 'DSP platform', sortable: true, type: 'string' },
//     // { id: 3, name: 'ioId', label: 'IO ID', sortable: true, type: 'number' },
//     // { id: 4, name: 'lastmodified', label: 'Last Modified Date', sortable: true, type: 'date'}
//     // { id: 5, name: 'endDate', label: 'End Date', sortable: true, type: 'date', component: (row) => row.endDate ? moment(row.endDate).format('DD-MMM-YY') : '' },
//     // {
//     //   id: 6, name: 'dealIdName', label: 'Dealid', sortable: true, type: 'string',
//     //   component: (row) => (<div> {row.dealIdNameDetail && row.dealIdNameDetail.map((a, i) => <div key={i}>{a}</div>)}</div>)
//     // },
//     // { id: 7, name: 'budget', label: 'Total Budget', sortable: true, type: 'number' },
//     // { id: 8, name: 'budgetLeft', label: 'Budget Left', sortable: true, type: 'number' },
//     // { id: 9, name: 'pacingStyle', label: 'Pacing', sortable: true, type: 'string' },
//     // { id: 10, name: 'goal', label: 'Goal', sortable: true, type: 'string' },
//     // { id: 11, name: 'impression', label: 'Impression Served', sortable: true, type: 'number' },
//     // { id: 12, name: 'click', label: 'Clicked', sortable: true, type: 'number' },
//     // { id: 13, name: 'ctr', label: 'CTR%', sortable: true, type: 'string' },
//     // { id: 14, name: 'recActiveName', label: 'Status', sortable: true, type: 'string' },
//     // { id: 15, name: 'date', label: 'Updated Date', sortable: true, type: 'date', component: (row) => moment(row.date).format('DD-MMM-YY') },
//   ],
//   keyCol: 'campaignId',
//   actions: [
//   //   {
//   //   type: 'edit',
//   //   text: '',
//   //   icon: 'mdi mdi-pencil',
//   //   tooltip: 'Edit'
//   // },
//   {
//     type: 'viewCampaign',
//     text: '',
//     icon: 'mdi mdi-eye',
//     tooltip: 'View Campign',
//   },
//   {
//     type: 'chart',
//     text: '',
//     icon: 'mdi mdi-chart-areaspline',
//     tooltip: 'View Campign',
//   },
//   {
//     type: 'error',
//     text: '',
//     icon: 'mdi mdi-alert',
//     tooltip: 'Error',
//   }
//     // ,{
//     //   type: 'delete',
//     //   text: '',
//     //   icon: 'mdi mdi-delete',
//     //   tooltip: 'Delete',
//     //   confirmation: true,
//     //   confirmationMessage: 'Kindly confirm the deletion of this record. This action cannot be undone.',
//     // }
//     , 
//   //   {
//   //   type: 'clone',
//   //   text: '',
//   //   icon: 'mdi mdi-vector-arrange-below',
//   //   tooltip: 'Clone',
//   // }

// ],
//     // recActive: true,
//     // status: {
//     //   key: 'recActive',
//     //   active: '1',
//     //   activeIcon: 'mdi mdi-checkbox-marked',
//     //   inActiveIcon: 'mdi mdi-close-box',
//     //   confirmation: true,
//     //   activeConfirmationMessage: 'Kindly confirm the deactivation of this record.',
//     //   inActiveConfirmationMessage: 'Please confirm if you wish to activate this record.',
//     // },
//   actionsThead: true,
//   sortable: true,
//   dateType: true,
//   defaultSortParams: {
//     sortBy: 'date',
//     sortOrder: 'desc'
//   },
//   paging: true,
//   defaultPagingParams: {
//     pageSize: 25
//   }
// };

export const optionsError = {
  columns: [
    { id: 1, name: 's.no', label: 'S.No', sortable: false, type: 'number', expand: false },
    { id: 2, name: 'campaignName', label: 'Campaign Name', sortable: false, type: 'string'},
    { id: 3, name: 'platform', label: 'Platform Name', sortable: false, type: 'string' , component: (row) => <div>{row.platform }</div>},
    { id: 3, name: 'type', label: 'Creative Type', sortable: false, type: 'string'},
    { id: 3, name: 'error', label: 'Error', sortable: false, type: 'string' , component: (row) => <div style={{whiteSpace:'break-spaces',lineHeight:'18px'}}>{row.error }</div> },
  ],
  actions:[{
    type: 'edit',
    text: '',
    icon: 'mdi mdi-pencil',
    tooltip: 'Error',
  }],
  keyCol: 'campaignName',
  actionsThead: true,
  sortable: true,
  dateType: true,
  paging: true,
  defaultPagingParams: {
    pageSize: 25
  }
};

export const bidderReport = [
  {
    campaignname: 'Shriram',
    advertisername: 'Shriram',
    ioid: 1,
    startDate: '2019-10-15',
    endDate: '2019-10-18',
    dealid: 'AN01',
    totalbudget: 10000,
    budgetleft: 8000,
    placing: 'Even',
    goal: 'Conversion',
    impressionserved: 1000000,
    clicked: 1100,
    ctr: '1%',
    state: 'Active',
  },
  {
    campaignname: 'Great Learning',
    advertisername: 'Great Learning',
    ioid: 2,
    startDate: '2019-10-15',
    endDate: '2019-10-18',
    dealid: 'BZ02',
    totalbudget: 12000,
    budgetleft: 9500,
    placing: 'Even',
    goal: 'Conversion',
    impressionserved: 1000000,
    clicked: 1100,
    ctr: '1%',
    state: 'Active',
  }
];

export const formFields = {
  startDate: {
    key: 'startDate',
    label: 'Start Date',
    // required: true,
    placeholder: 'Start Date',
    displayLayout: 'col-md-7',
    // requiredMessage: 'Start Date is required.',
    tooltip: '<div> Start Date </div>'
  },
  endDate: {
    key: 'endDate',
    label: 'End Date',
    // required: true,
    placeholder: 'End Date',
    displayLayout: 'col-md-7',
    // requiredMessage: 'End Date is required.',
    tooltip: '<div> End Date </div>'
  },
  budgetFrom: {
    key: 'budgetFrom',
    type: 'text',
    label: 'Budget is from',
    displayLayout: 'col-md-7',
  },
  budgetTo: {
    key: 'budgetTo',
    type: 'text',
    label: 'to',
    displayLayout: 'col-md-7',
  },
  advertiserId: {
    key: 'advertiserId',
    label: 'Advertiser Name is',
    displayLayout: 'col-md-7',
    valueKey: 'key',
    textKey: 'value',
    // required: true,
    // placeholder: 'Select',
    // requiredMessage: 'Advertiser is required.',
    // tooltip: '<div> Advertiser </div>'
  },
  advertiserId: {
    key: 'advertiserId',
    label: 'Select Advertiser',
    required: true,
    placeholder: 'Select',
    requiredMessage: 'Advertiser is required.',
    displayLayout: 'col-md-7',
    valueKey: 'key',
    textKey: 'value',
    tooltip: '<div> Advertiser </div>'
  },
  campaign: {
    key: 'campaign',
    label: 'Select Advertiser',
    required: true,
    placeholder: 'Select',
    requiredMessage: 'Advertiser is required.',
    displayLayout: 'col-md-7',
    valueKey: 'key',
    textKey: 'value',
    tooltip: '<div> Advertiser </div>'
  },
  dspPlatform: {
    key: 'dspPlatform',
    label: 'Select Advertiser',
    required: true,
    placeholder: 'Select',
    requiredMessage: 'Advertiser is required.',
    displayLayout: 'col-md-7',
    valueKey: 'key',
    textKey: 'value',
    tooltip: '<div> Advertiser </div>'
  },
  creativeType: {
    key: 'creativeType',
    label: 'Select Advertiser',
    required: true,
    placeholder: 'Select',
    requiredMessage: 'Advertiser is required.',
    displayLayout: 'col-md-7',
    valueKey: 'key',
    textKey: 'value',
    tooltip: '<div> Advertiser </div>'
  },

};

export const noMetricMessage = "No metrics fetched for this campaign yet";


